import { motion } from "framer-motion";
import { Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export const Contact = ({ settings }) => {
  const waNumber = (settings.whatsapp || "").replace(/\D/g, "").replace(/^0/, "44");
  return (
    <section id="contact" className="py-20 sm:py-24 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-blue-600 mb-4">About PRGL</p>
          <h2 className="text-4xl sm:text-5xl tracking-tight font-semibold text-slate-900">Who we are</h2>
          <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl" data-testid="about-text">
            At PRGL, we supply fully-equipped vans and trained two-man crews to get deliveries, removals and
            installations done right — across home, retail, construction and more. With over 10 years of
            experience, we've built a reputation for reliability, care and a job done properly every time.
          </p>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}
          className="bg-white border border-slate-200 rounded-lg p-8 sm:p-10 shadow-[0_2px_8px_rgba(15,23,42,0.04)]">
          <h3 className="text-2xl font-medium text-slate-900 mb-7">Contact us</h3>
          <div className="space-y-5">
            <Button asChild data-testid="contact-whatsapp-btn"
              className="w-full h-12 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-md text-base justify-start px-5">
              <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noopener noreferrer">
                <WhatsAppIcon className="mr-3" /> Message us on WhatsApp
              </a>
            </Button>
            <div className="flex items-center gap-3 text-slate-700" data-testid="contact-phone">
              <Phone size={18} className="text-blue-600" />
              <a href={`tel:${settings.phone}`} className="hover:text-blue-700 transition-colors font-medium">{settings.phone}</a>
            </div>
            <div className="flex items-center gap-3 text-slate-700" data-testid="contact-email">
              <Mail size={18} className="text-blue-600" />
              <a href={`mailto:${settings.email}`} className="hover:text-blue-700 transition-colors font-medium">{settings.email}</a>
            </div>
            <div className="flex items-center gap-3 text-slate-700" data-testid="contact-address">
              <MapPin size={18} className="text-blue-600" />
              <span>{settings.address}</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
